import { useEffect, useState } from "react";
import ProjectListItem from "../components/ProjectListItem";
import Loading from "./Loading";
import PageHeader from "../components/PageHeader";

export default function Projects(){

  const bucketUrl = "https://storage.googleapis.com/imajindev";

  const categories = ["Webapp", "Education", "UX/UI"];
  const data = [
     {
            id : "1bcafaf7-b684-8038-ac23-d66bc67f4193",
            title : "Teamstamps",
            impact : "Under test with a basketball league that holds season leagues with avg. 10 teams, 90 players, and 65 games.",
            date : "2025.01 - Current",
            summary : "Team Stamps is a team management tool designed for amateur sports leagues. The product aims to motivate players by bringing in professional broadcast experience through animated game graphics, player highlights, and stats.",
            link : "https://team-stamps.com/pfl/games",
            role : "Fullstack Developer",
            stack : `Frontend : React.js
Backend : Node.js`,
            videoSrc : [
                { url: "assets/teamstamps1.mp4", full: true },
            ],
            thumbnail : `${bucketUrl}/thumb_teamstamps.png`,
            type : "Webapp"
        },
        {
            id : "2adafaf7-b684-80bc-9e30-e0b67fa113bb",
            title : "Daily Creative Coding",
            impact : "I’ve been posting daily sketch since Aug 1, 2023.",
            date : "2023.08.01 - Current",
            summary : "Experimenting around animations and educational interactive sketches. I also create custom graphics for video sources.",
            link : "https://www.instagram.com/coding.effects/",
            role : "Fullstack Developer",
            stack : ``,
            videoSrc : [
                { url : "assets/dailycc1.mp4", full : true },
            ],
            thumbnail : `${bucketUrl}/thumb_dailycc.png`,
            type : "Education"
        },
        {
            id : "25eafaf7-b684-80f5-916a-d572bdb527e0",
            title : "Graphbook",
            impact : "Alpha version released, under user test with two university professors to be used for courses and workshops.",
            date : "2025.07 - Current",
            summary : "Graphbook is an interactive blog editor built for creative coders and educators. It lets you write text, code, and present seamlessly in one place.",
            link : "https://graphbook.app/",
            role : "Design Engineer",
            stack : `Frontend : React.js
Database : Supabase
Deployment : Vercel`,
            videoSrc : [
                { url : "assets/interactiveblog.mp4", full : true },
            ],
            thumbnail : `${bucketUrl}/thumb_graphbook.png`,
            type : "Webapp"
        },
        {
            id : "170afaf7-b684-80e3-a118-c72096f5710e",
            title : "Quotes",
            impact : "Used internally in a weekly reading club since 2024.",
            date : "2024.03 - 2025.03",
            summary : "Quotes is a minimalistic editor designed to motivate your reading and writing experience.",
            link : "https://www.instagram.com/coding.effects/",
            role : "Fullstack Developer",
            stack : `Frontend : Next.js
Database : Postgres
Deployment : Vercel`,
            videoSrc : [
                { url : "assets/quotes.mp4", full : false },
            ],
            thumbnail : bucketUrl + "/thumb_quotes.jpg",
            type : "Webapp"
        },
         {
          id : "334afaf7-b684-80d2-bcd1-e38af9cb774b",
          title : "Kinetic Typos Library",
          impact : "",
          date : "",
          summary : "",
          link : "",
          role : "",
          stack : ``,
          videoSrc : [
              { url : "", full : false },
          ],
          thumbnail : bucketUrl + "/thumb_kinetictypos.png",
          type : "Webapp"
        },
        {
          id : "2adafaf7-b684-8019-ad1a-dd3ef3938d7b",
          title : "ml5.js Object Detection",
          impact : "",
          date : "",
          summary : "",
          link : "",
          role : "",
          stack : ``,
          videoSrc : [
              { url : "", full : false },
          ],
          thumbnail : bucketUrl + "/thumb_ml5.png",
          type : "Webapp"
        },
        {
          id : "2b3afaf7-b684-8007-88b5-dbdf9b2c097b",
          title : "Wave, a speaker for everyone",
          impact : "",
          date : "",
          summary : "",
          link : "",
          role : "",
          stack : ``,
          videoSrc : [
              { url : "", full : false },
          ],
          thumbnail : bucketUrl + "/thumb_wave.jpg",
          type : "UX/UI"
        },
        {
          id : "170afaf7-b684-807a-85b9-c2bddc99d8ea",
          title : "React with Notion as Database",
          impact : "",
          date : "",
          summary : "",
          link : "",
          role : "",
          stack : ``,
          videoSrc : [
              { url : "", full : false },
          ],
          thumbnail : bucketUrl + "/thumb_notion.jpg",
          type : "Education"
        },
                {
          id : "1e1afaf7-b684-80ff-aafa-f7459484715a",
          title : "Konkrit",
          impact : "",
          date : "",
          summary : "",
          link : "",
          role : "",
          stack : ``,
          videoSrc : [
              { url : "", full : false },
          ],
          thumbnail : bucketUrl + "/thumb_konkrit.png",
          type : "UX/UI"
        },
               {
          id : "1e1afaf7-b684-802c-8fe2-d638e02b56df",
          title : "Sprint",
          impact : "",
          date : "",
          summary : "",
          link : "",
          role : "",
          stack : ``,
          videoSrc : [
              { url : "", full : false },
          ],
          thumbnail : bucketUrl + "/thumb_sprint.jpg",
          type : "UX/UI"
        },
               {
          id : "1e1afaf7-b684-80d2-be1d-c8dfab696715",
          title : "imajinOS",
          impact : "",
          date : "",
          summary : "",
          link : "",
          role : "",
          stack : ``,
          videoSrc : [
              { url : "", full : false },
          ],
          thumbnail : bucketUrl + "/thumb_imajinos.png",
          type : "Webapp"
        },
              {
          id : "202afaf7-b684-80ff-9605-d93d841f609e",
          title : "Imperative",
          impact : "",
          date : "",
          summary : "",
          link : "",
          role : "",
          stack : ``,
          videoSrc : [
              { url : "", full : false },
          ],
          thumbnail : bucketUrl + "/thumb_imperative.png",
          type : "Webapp"
        },
              {
          id : "1e1afaf7-b684-8039-b796-d26d6423d335",
          title : "reimagine(p5js)",
          impact : "",
          date : "",
          summary : "",
          link : "",
          role : "",
          stack : ``,
          videoSrc : [
              { url : "", full : false },
          ],
          thumbnail : bucketUrl + "/thumb_p5.png",
          type : "Webapp"
        },
              {
          id : "1e1afaf7-b684-8019-b05e-dad34506c5be",
          title : "Codot",
          impact : "",
          date : "",
          summary : "",
          link : "",
          role : "",
          stack : ``,
          videoSrc : [
              { url : "", full : false },
          ],
          thumbnail : bucketUrl + "/thumb_codot.png",
          type : "Webapp"
        },
              {
          id : "171afaf7-b684-8037-be5c-d1ccab3c80a6",
          title : "Math and Physics for Creative Coders",
          impact : "",
          date : "",
          summary : "",
          link : "",
          role : "",
          stack : ``,
          videoSrc : [
              { url : "", full : false },
          ],
          thumbnail : bucketUrl + "/thumb_mpcc.jpg",
          type : "Education"
        },
              {
          id : "2ecafaf7-b684-8066-a02c-fcfb511bd71a",
          title : "UX Internship @SAP",
          impact : "",
          date : "",
          summary : "",
          link : "",
          role : "",
          stack : ``,
          videoSrc : [
              { url : "", full : false },
          ],
          thumbnail : bucketUrl + "/thumb_sap.png",
          type : "UX/UI"
        },
                      {
          id : "2ecafaf7-b684-8040-8fde-edf4da622937",
          title : "UX Internship @Naver",
          impact : "",
          date : "",
          summary : "",
          link : "",
          role : "",
          stack : ``,
          videoSrc : [
              { url : "", full : false },
          ],
          thumbnail : bucketUrl + "/thumb_naver.png",
          type : "UX/UI"
        },

  ]

  const [activeTag, setActiveTag] = useState(""); // Selected Category
  const [loading, setLoading] = useState(false);
  const [lastEdited, setLastEdited] = useState("Mar 30, 2026");


  return(
    <>
      { loading ? <Loading/> :
        <div className = "page">

        <PageHeader title = "Works" date = { lastEdited }/>
          
        <div style = { { flexWrap : "wrap", display : "flex", alignItems : "center", justifyContent : "center", gap : "1px", paddingTop : "16px" } } className = "meta">
          <p 
            className={`categoryP ${activeTag === null ? 'active' : ''}`}
            onClick={() => setActiveTag(null)}
          >
            All
          </p>

          { categories.map((item, index) => (
            <p 
              key={index} 
              className={`categoryP ${activeTag === item ? 'active' : ''}`}
              onClick={() => setActiveTag(item)}
            >
              {item}
            </p>
          ))}
          
        </div>

        <br/><br/>
        
        { data
            .filter(item => !activeTag || item.type === activeTag)
            .map((item, index) => (
              // quotes
              <ProjectListItem key={index} item={item} backgroundPosition={item.id === "170afaf7-b684-80e3-a118-c72096f5710e" ? "top" : "center"} />
            ))}
        
      </div>
      }
    </>
  );
}